import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, CanActivateChild, Router } from "@angular/router";
import { Observable, Subject } from "rxjs";
import { SessionService } from "../session";


/**
 * Prevent a non admin from accessing the settings section
 */
@Injectable()
export class CanAccessSettingsGuard implements CanActivate, CanActivateChild {

  constructor(private sessionService: SessionService, private router: Router)
  { }

  private isAdmin(): Observable<boolean> {
    let subject = new Subject<boolean>();

    let sub = this.sessionService.currentUser.subscribe((user) => {
      // Force redirect to /
      if(!user.is_admin) {
        this.router.navigate(['/']);
      }

      // Only admin can view settings
      subject.next(user.is_admin);

      // Cleanup
      subject.complete();
      sub.unsubscribe();
    });


    return subject;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.isAdmin();
  }


  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.isAdmin();
  }
}